/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";

import type { AddressInfo } from "modules/auth";
import type { FC } from "react";

export const LiveCommerceAddress: FC<{
  isDarkModeEnabled: boolean;
  addressInfo: AddressInfo;
}> = ({ isDarkModeEnabled, addressInfo }) => {
  const { t } = useI18n();
  return (
    <div
      css={css`
        display: grid;
        grid-template-columns: 1fr max-content;
        align-items: center;
        gap: 16px;
        padding: 16px 16px 12px;
        color: ${isDarkModeEnabled ? "#fff" : "#000"};
        background-color: ${isDarkModeEnabled ? "#141414" : "#f5f5f5"};
        border: 1px solid;
        border-color: ${isDarkModeEnabled
          ? "rgba(255, 255, 255, 0.2)"
          : "#e0e0e0"};
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          gap: 8px;
        `}
      >
        <p
          css={css`
            font-size: 14px;
            font-weight: 700;
          `}
        >
          {addressInfo.userName}
        </p>

        <div
          css={css`
            font-size: 14px;
            line-height: 1.5;
          `}
        >
          {addressInfo.zipCode}
          {` ${addressInfo.prefecture}`}
          {` ${addressInfo.city}`}
          {` ${addressInfo.streetNum}`}
          {addressInfo.buildingInfo && ` ${addressInfo.buildingInfo}`}
        </div>
      </div>

      <div>
        <a
          href="/account/address"
          target="_blank"
          rel="noopener noreferrer"
          css={css`
            color: ${isDarkModeEnabled ? "#fff" : "#000"};
            font-size: 14px;
            font-weight: 700;
            cursor: pointer;
          `}
        >
          {t("streaming.commerceCart.edit")}
        </a>
      </div>
    </div>
  );
};
